import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Contact Form Section - slide in from left
 */
export const animateContactForm = (ref) => {
  if (ref.current) {
    const element = ref.current;
    
    // Set initial state immediately to prevent flash
    gsap.set(element, { opacity: 0, x: -80 });
    
    const timer = setTimeout(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          toggleActions: "play none none none",
          once: true,
        },
      });

      tl.to(element, {
        opacity: 1,
        x: 0,
        duration: 1.2,
        ease: "power3.out",
      });
      
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

